module.exports = __webpack_public_path__ + "static/media/SP_S_Fashion_Necchi_Blue_Orange.f7d85703.png";